import { CoursePathSegment } from '@/data/hook/course-line/useCoursesSegments';
import Observable from '../observers/ObserverPattern';
import { Tree } from './Tree';

export type CoursesModelsType =
  | 'courseLine'
  | 'module'
  | 'course'
  | 'unit'
  | 'lesson';

export type CoursesNode = {
  id: string;
  realId: number | string;
  name: string;
  type: CoursesModelsType | 'root';
  href?: string;
};

export type TreeCoursesConstructorProps = {
  root: CoursesNode;
  segments?: CoursePathSegment[];
};

export default class TreeCourses extends Tree<string, CoursesNode> {
  observer: Observable<string, CoursesNode[]>;
  segments: CoursePathSegment[];
  currentSegment?: CoursePathSegment;
  constructor({ root, segments }: TreeCoursesConstructorProps) {
    super(root);
    this.observer = new Observable<string, CoursesNode[]>();
    this.segments = segments ?? [];
    this.currentSegment = this.segments.at(-1);
  }

  setSegments = (segments: CoursePathSegment[]) => {
    this.segments = segments;
    this.currentSegment = this.segments.at(-1);
    this.observer.notifyAll(
      undefined,
      this.findPath(this.currentSegment?.key ?? '') ?? [],
    );
  };

  notifyTreeUpdate = (courseLine: CoursesNode) => {
    if (this.currentSegment?.key === courseLine.id)
      this.observer.notifyAll(undefined, this.findPath(courseLine.id) ?? []);
  };

  insert = (courseLine: CoursesNode, parentElementId?: string) => {
    if (this.nodes[courseLine.id]) return;
    super.insert(courseLine, parentElementId);
    this.notifyTreeUpdate(courseLine);
  };

  update = (courseLine: Partial<CoursesNode> & { id: string }) => {
    super.update(courseLine);
    if (this.segments.some(segment => segment.key === courseLine.id)) {
      this.observer.notifyAll(undefined, this.findPath(courseLine.id) ?? []);
    }
  };
}
